import { PriceGroupCode, IPriceGroupCode } from "./PriceGroupCode";

export class PriceGroup implements IPriceGroup {
    priceGroupId: number;
    name: string;
    priceGroupTypeCode: string;
    priceCodes: PriceGroupCode[];

    constructor(priceGroup?: IPriceGroup) {
        this.priceGroupId = priceGroup?.priceGroupId ?? 0;
        this.name = priceGroup?.name ?? "";
        this.priceGroupTypeCode = priceGroup?.priceGroupTypeCode ?? "";
        if (priceGroup != null && priceGroup.priceCodes != null)
            this.priceCodes = priceGroup.priceCodes.map((ipc) => new PriceGroupCode(ipc));
        else this.priceCodes = [];
    }
}

export interface IPriceGroup {
    priceGroupId: number;
    name: string;
    priceGroupTypeCode: string;
    priceCodes: IPriceGroupCode[];
}